import { OptionType } from '@evinced-private/ui-common';

import { IWebSdkTest } from 'src/apps/web-sdks/types/WebSdkDashboardServiceTypes';
import { ConfigurationLabel } from 'src/common/types/ConfigurationTypes';

import {
	buildDisplayNameToKeyMap,
	extractLabelKey,
	getExistingLabelsFromRows,
	transformLabelValuesToOptions
} from '../../shared/helpers';

export const extractLabelOptionsFromTestRows = (
	testRows: IWebSdkTest[],
	allLabels: ConfigurationLabel[]
): OptionType[] => {
	if (!testRows?.length || !allLabels?.length) {
		return [];
	}

	const existingLabels = getExistingLabelsFromRows(testRows, allLabels);

	return existingLabels
		.map((label) => ({ value: label, label }))
		.sort((a, b) => a.label.localeCompare(b.label));
};

export const transformCoreLabelsToOptions = (
	allLabels: ConfigurationLabel[],
	selectedLabel?: string
): OptionType[] => {
	if (!selectedLabel) {
		return transformLabelValuesToOptions(allLabels);
	}

	const displayNameMap = buildDisplayNameToKeyMap(allLabels);
	const selectedKey = extractLabelKey(selectedLabel, displayNameMap);

	return transformLabelValuesToOptions(allLabels, selectedKey);
};
